/* unplugin-vue-components disabled */import script from "./image-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./image-item.vue?vue&type=script&setup=true&lang=ts"

import "./image-item.vue?vue&type=style&index=0&id=61f92acd&lang=scss"

const __exports__ = script;

export default __exports__